import DataLoader from "../../../../../components/ui/dataLoader/DataLoader";
import NoRecordFound from "../../../../../components/ui/noRecordFound/NoRecordFound";
import CostAllocationTable from "./components/CostAllocationTable";
import ModelGroupingTable from "./components/ModelGroupingTable";
import ReadOnlyField from "./components/ReadOnlyField";
import { useCertificateGroupingView } from "./hook/useCertificateGroupingView";

const CertificateGrouping = ({ productInfoID, typeId }) => {
  const {
    config, products, costRows, isLoading,
    caseOfficerComment, peerReviewerComment, approverComment,
    peerReviewerName, approverName,
  } = useCertificateGroupingView(productInfoID, Number(typeId));

  if (!config) return <NoRecordFound />; 

  if (isLoading) return <DataLoader/>;

  return (
    <div className="certificate-grouping-list-page">      

      <ModelGroupingTable data={products} showRating={config.showRating} />
      <CostAllocationTable rows={costRows} showTick={config.showTick} />

      <div className="table-title mt-5 mb-4">
        <h3>Internal Notes</h3>
      </div>
      <ReadOnlyField multiline label="Comments from Case Officer" value={caseOfficerComment} />

      <div className="table-title mt-5 mb-4">
        <h3>Assigned to</h3>
      </div>
      <div className="dropdown-select-wrapper">
        <ReadOnlyField inline label="Peer Reviewer" value={peerReviewerName} />
        <ReadOnlyField inline label="Approver" value={approverName} />
      </div>
    </div>
  );
};

export default CertificateGrouping;